/* 
    BookCard component is used to show the listing of the books
    This component accepts following proptypes.
    @param Books - Books list
    @param AffiliateCode - Amazon Preview_Link_Affiliate_Code
    @param SiteId - siteId
*/

import React from 'react';
import PropTypes from 'prop-types';
import {
    findSiteName,
    appendHttpsToUrl,
    formatImageUrl,
    formatUrl
} from '../../helpers/Helper';
import NextImage from '../../components/Image/NextImage';
import styles from './RelatedPostCard.module.css';

const createPostLinks = (siteId, slug) => {
    let siteName = findSiteName(siteId);
    return appendHttpsToUrl(`${siteName}/${slug}`);
}

export const RelatedPostCard = (props) => {
    return props.RelatedPosts && props.RelatedPosts.map((post, index) => {
        return (
            <React.Fragment key={post._id || post.slug || index}>
                <div className={styles.postCard}>
                    <div className="post-card-image-wrap">
                        <a href={createPostLinks(post.site_id, formatUrl(post.slug, post.redirect))} target='_blank' rel='noopener'>
                            <div className={styles.postOverlay}>
                                <NextImage
                                    ImageUrl={formatImageUrl(post.featured_media.name, "sm")}
                                    Title={post.featured_media.title}
                                    target='_blank'
                                    Alt_Text={post.featured_media.alt_text}
                                    className='post-card-img'
                                    width={200}
                                    height={0}
                                />
                            </div>
                            <span className={styles.postTitle} dangerouslySetInnerHTML={{ __html: post.title }} />
                        </a>
                    </div>
                </div>
            </React.Fragment>
        )
    })
}

RelatedPostCard.propTypes = {
    RelatedPosts: PropTypes.array.isRequired,
}

export default RelatedPostCard;